module.exports = __webpack_public_path__ + "img/entj.b4c613cc.png";